export const AUTH_FULL_PAGE_REDIRECT = 'auth_full_page_redirect';
export const EMPTY_CART_FEATURE_VARIANT = 'empty_cart_feature_variant';
export const SHOPPING_CART_VARIANT_MOBILE = 'shopping_cart_variant_mobile';

export const DELAYED_ACCOUNT_CREATION_ON_CHECKOUT_PAGE =
    'delayed_account_creation_on_checkout_page';

export const CART_UPSELL_FEATURE = 'cart_upsell_module_feature';

export const CART_RECOMMENDATION_FEATURES = 'cart_recommendations_features';

export enum CartUpsellFeatureVariation {
    Control = 'control',
    ALaCarte = 'a-la-carte',
    Bundled = 'bundled',
}
